/**
Copyright (C) 2018 Andras Sarvari <andras.sarvari@sarvaria.net>

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted, provided that the above
copyright notice and this permission notice appear in all copies.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES
WITH REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF
MERCHANTABILITY AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR
ANY SPECIAL, DIRECT, INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES
WHATSOEVER RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER IN AN
ACTION OF CONTRACT, NEGLIGENCE OR OTHER TORTIOUS ACTION, ARISING OUT OF
OR IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.
*/

/* jshint browser: true, esversion: 6, node:true */
/* globals console */

import React from 'react';
import PropTypes from 'prop-types';
import Control from '../Control/Control';
import './Label.css';

/**
 * Represents the label component.
 */

export default class Label extends Control {

    /**
     * Properties.
     */

    static propTypes = {
        text:               PropTypes.string.isRequired,
        isrequired:         PropTypes.bool,
        disabled:           PropTypes.bool,
        link:               PropTypes.bool,
        tooltip:            PropTypes.string,
        requiredmessage:    PropTypes.string,
        width:              PropTypes.number,
        onTouch:            PropTypes.func
    }

    /**
     * Default property values.
     */

    static defaultProps = {
        requiredmessage:    'Mandatory field'
    }

    /**
     * Gets the style of the label.
     * 
     * @return  {Object}    style   style of the label
     */

    getStyle = () => {

        // Preparing

        let style = this._getStyle();
        
        // Adding style attributes
        
        style.width = this.props.width + 'px';

        // Setting cursor

        if (this.props.onTouch) {
            style.cursor = 'pointer';
        }

        // Returns the style

        return style;
    }
    
    /**
     * Label renderer.
     */

    render() {

        /**
         * Splits the specified text by using new lines.
         * 
         * @param   {String}    text        text that has to split
         * @return  {Object}    textElement generated text element
         */
        
        let breakLine = (text) => {
            let br = React.createElement('br');
            let regex = /\n/g;
            let lines = ('' + text).split(regex);

            return lines.map((line, index) => {
                if (index > 0) {
                    return <span key={"key_" + index}><br/>{line}</span>;
                } else {
                    return line;
                }
            });
        };

        return (
            <div className="horizontal center" title={this.props.tooltip} style={this.getStyle()} onClick={this.props.onTouch}>
                <div className={`label ${this.props.disabled ? 'label-disabled' : (this.props.link ? 'label-link' : 'label-enabled')}`}>{breakLine(this.props.text || '')}</div>
                { this.props.isrequired && <div className="label-required" title={this.props.requiredmessage}>!</div>}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Label/Label.js